import React from "react"
import numeral from "numeral"

class MondayAmountMinimumStayDataType extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {    
    var data = this.props.row['monday_amount'] || 0;

    return (
      <div>
        {numeral(data / 100).format(this.props.currency_unit + '0' + this.props.delimiter + '0' + this.props.separator + '00')}
        {this.props.row['monday_minimum_stay'] ? <hr style={{marginTop: 5, marginBottom: 5}} /> : null}
        {this.props.row['monday_minimum_stay'] ? <span>{this.props.row['monday_minimum_stay']} {I18n.t('night')} {I18n.t('min_stay')}</span> : null}
      </div>
    );
  }

};

export default MondayAmountMinimumStayDataType